/* Native details remain usable without JavaScript; no resize-time listeners. */
if (!customElements.get('bioself-footer')) {
  customElements.define('bioself-footer', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = window.matchMedia('(max-width: 1000px)');
      this.syncMenus = () => {
        const mobile = this.breakpoint.matches;
        this.querySelectorAll('.bioself-footer__menu').forEach((menu) => {
          menu.open = !mobile || this.dataset.collapseMobile !== 'true';
          menu.querySelector('summary').tabIndex = mobile ? 0 : -1;
        });
      };
      this.handleClick = (event) => {
        if (!this.breakpoint.matches && event.target.closest('summary')) event.preventDefault();
      };
      this.handleBlockSelect = (event) => {
        const menu = event.target.closest('.bioself-footer__menu');
        if (menu) menu.open = true;
      };
      this.breakpoint.addEventListener('change', this.syncMenus);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.syncMenus();
    }

    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.syncMenus);
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
  });
}
